














import { defineComponent } from '@vue/composition-api';

import InitiateAnalysisMenu from './InitiateAnalysisMenu.vue';
import CompletedAnalysesMenu from './CompletedAnalysesMenu.vue';
import { initiateAnalysisOpen } from '../state';

export default defineComponent({
  name: 'Analysis',
  components: { InitiateAnalysisMenu, CompletedAnalysesMenu },
  setup() {
    return { initiateAnalysisOpen };
  },
});
